module.exports = __webpack_public_path__ + "static/media/album.18fff2bf.less";